.stepContent {
  display: flex;
  flex-direction: column;
  gap: var(--hcr-spacing-2);
}
